import axios from 'axios'
import { Const } from './config'
import jwtService from './mixins/JwtStorageService'

// Powiadamianie o błędach HTTP — main.js podpina tu toast po utworzeniu
// instancji Vue (interceptory nie mają dostępu do $bvToast).
let notifyError = () => {}

export function setErrorNotifier(fn) {
    notifyError = fn
}

// Osobna instancja axios do odświeżania tokenu — bez interceptorów, żeby 401
// z samego refresha nie wpadał z powrotem do kolejki oczekujących żądań
// (wcześniej powodowało to deadlock: promise z kolejki nigdy się nie rozstrzygał).
const refreshClient = axios.create()

let isRefreshing = false
let failedQueue = []

const processQueue = (error, token = null) => {
    failedQueue.forEach(prom => {
        if (error) {
            prom.reject(error)
        } else {
            prom.resolve(token)
        }
    })
    failedQueue = []
}

function hardLogout() {
    jwtService.removeLoginData()
    window.location.href = '/login?sessionExpired=true'
}

export function installInterceptors() {
    axios.interceptors.request.use(
        config => {
            const token = jwtService.getAccessToken()
            if (token) {
                config.headers['Authorization'] = 'Bearer ' + token
            }
            config.headers['Content-Type'] = 'application/json'
            return config
        },
        error => Promise.reject(error)
    )

    axios.interceptors.response.use(
        response => response,
        error => {
            // Błąd sieci / timeout — error.response nie istnieje.
            if (!error.response) {
                notifyError('errors.network')
                return Promise.reject(error)
            }

            const originalRequest = error.config
            const status = error.response.status
            const isLoginRequest = originalRequest.url.indexOf('/login') !== -1

            if (status === 401 && !isLoginRequest && !originalRequest._retry) {
                if (isRefreshing) {
                    return new Promise((resolve, reject) => {
                        failedQueue.push({ resolve, reject })
                    }).then(token => {
                        originalRequest.headers['Authorization'] = 'Bearer ' + token
                        return axios(originalRequest)
                    })
                }

                originalRequest._retry = true
                isRefreshing = true

                return refreshClient.post(Const.API_HOST + '/oauth/access_token', {
                    grant_type: 'refresh_token',
                    refresh_token: jwtService.getRefreshToken()
                }).then(({ data }) => {
                    jwtService.setAccessToken(data.access_token)
                    jwtService.setRefreshToken(data.refresh_token)
                    originalRequest.headers['Authorization'] = 'Bearer ' + data.access_token
                    processQueue(null, data.access_token)
                    return axios(originalRequest)
                }).catch(refreshError => {
                    processQueue(refreshError, null)
                    hardLogout()
                    return Promise.reject(refreshError)
                }).finally(() => {
                    isRefreshing = false
                })
            }

            if (status !== 401 && !isLoginRequest) {
                notifyError('errors.request')
            }
            return Promise.reject(error)
        }
    )
}
